/**
 * useGoToHelpArticle — shared by HomeTab and HelpTab: full article content
 * (long text, images, video) doesn't fit the 384px panel, so an article
 * card click opens the full-page reading experience at /help/:articleId in a
 * NEW browser tab. The widget stays open in the current tab so the user can
 * keep browsing the knowledge center list where they left off.
 */

import { helpArticlePath } from '../../../routes/paths';

export function useGoToHelpArticle() {
  return (articleId: string) => {
    window.open(helpArticlePath(articleId), '_blank', 'noopener');
  };
}
